import type { IListEmptyProps } from './IListEmptyProps';

/** Порожній список (UIUX patterns/empty-states, прототип v4 L719-724): пунктирна рамка, одне речення й дія — «+ Створити …» або «Скинути фільтри». */
export function ListEmpty({ text, actionText, onAction }: IListEmptyProps) {
  return (
    <div className="lv-empty" role="status">
      <span>{text}</span>
      {actionText && onAction && (
        <div className="lv-empty__actions">
          <button type="button" className="lv-tbtn" onClick={onAction}>{actionText}</button>
        </div>
      )}
    </div>
  );
}
